import { RECOVER_MESSAGE_TYPES } from "@redotech/redo-model/marketing/recover-message-defaults";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const recoverTemplateSchema_ = z.object({
  type: createEnum(RECOVER_MESSAGE_TYPES),
  label: z.string(),
  content: z.string(),
});
export const recoverTemplateSchema: z.ZodType<RecoverTemplate> =
  recoverTemplateSchema_;
export interface RecoverTemplate
  extends z.infer<typeof recoverTemplateSchema_> {}

export const getRecoverTemplates = {
  name: "getRecoverTemplates" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    templates: z.array(recoverTemplateSchema).optional(),
    originalContent: z.string().optional(),
    contractorEmail: z.string().optional(),
    errorMessage: z.string().optional(),
  }),
};
